import { FaEnvelope, FaMapMarkedAlt, FaClock, FaPhoneAlt } from "react-icons/fa";

const contacts = [
    {
        id: 1,
        icon: <FaMapMarkedAlt />, // MapMarkedAlt icon
        title: "address",
        content: ["LockWise Security Hub, 789 Secure Street"]
    },
    {
        id: 2,
        icon: <FaPhoneAlt />, // PhoneAlt icon
        title: "call us",
        content: ["+111-222-333", "+123-456-7890"],
    },
    {
        id: 3,
        icon: <FaEnvelope />, // Envelope icon
        title: "mail us",
        content: ["info@example.com", "xyz@gmail.com"],
    },
    {
        id: 4,
        icon: <FaClock />, // Clock icon
        title: "opening hours",
        content: ["Mon - Fri: 7 AM - 7 PM", "Sat - Sun: 8 AM - 6 PM"],
    },
];

export default contacts;